import { createContext } from 'react';

import type { IFiatWithdrawRequestContext } from '../../../DialogWithdrawRequest.helpers';

export const FiatWithdrawRequestContext = createContext<IFiatWithdrawRequestContext | null>(null);
